import { Fragment, useState } from "react";
import { Button, ButtonProps, Paper } from "@material-ui/core";
import { DialogWithActions } from "../dialog_with_actions";
import { ApartmentGuestsEditor } from "../apartment_guests_editor/apartment_guests_editor";

export interface ApartmentGuestsEditorButtonWithDialogProps
  extends Omit<ButtonProps, "onClick"> {
  apartmentId: string;
  onAddOrRemove?: () => void;
}

export function ApartmentGuestsEditorButtonWithDialog(
  props: ApartmentGuestsEditorButtonWithDialogProps
) {
  const { apartmentId, children, onAddOrRemove, ...buttonProps } = props;
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <Button {...buttonProps} onClick={() => setOpen(true)}>
        {children ?? "GESTISCI OSPITI"}
      </Button>
      <DialogWithActions
        open={open}
        setOpen={setOpen}
        fullScreen={true}
        title={"Gestisci ospiti"}
      >
        <Paper elevation={3} style={{ padding: "1rem" }}>
          <ApartmentGuestsEditor
            apartment={apartmentId}
            onGuestAdded={onAddOrRemove}
            onGuestRemoved={onAddOrRemove}
          />
        </Paper>
      </DialogWithActions>
    </Fragment>
  );
}
